module.exports = __webpack_public_path__ + "static/media/draggable.6880d644.svg";